/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyTaskType
 */
export interface ReadOnlyTaskType {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTaskType
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTaskType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTaskType
     */
    category?: ReadOnlyTaskTypeCategoryEnum;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyTaskType
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyTaskType
     */
    deletedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTaskType
     */
    repetitionDueDateType?: ReadOnlyTaskTypeRepetitionDueDateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyTaskType
     */
    repetitionDueDateValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyTaskType
     */
    readonly deleted?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyTaskType
     */
    customizable?: boolean;
}

export function ReadOnlyTaskTypeFromJSON(json: any): ReadOnlyTaskType {
    return ReadOnlyTaskTypeFromJSONTyped(json, false);
}

export function ReadOnlyTaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyTaskType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (json['deleted_at'] === null ? null : new Date(json['deleted_at'])),
        'repetitionDueDateType': !exists(json, 'repetition_due_date_type') ? undefined : json['repetition_due_date_type'],
        'repetitionDueDateValue': !exists(json, 'repetition_due_date_value') ? undefined : json['repetition_due_date_value'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'customizable': !exists(json, 'customizable') ? undefined : json['customizable'],
    };
}

export function ReadOnlyTaskTypeToJSON(value?: ReadOnlyTaskType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'category': value.category,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'repetition_due_date_type': value.repetitionDueDateType,
        'repetition_due_date_value': value.repetitionDueDateValue,
        'customizable': value.customizable,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyTaskTypeCategoryEnum {
    Vehicle = 'vehicle',
    Company = 'company',
    Driver = 'driver',
    Trailer = 'trailer'
}
/**
* @export
* @enum {string}
*/
export enum ReadOnlyTaskTypeRepetitionDueDateTypeEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}


